import { useMutation, useQueryClient } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import axios from '../../../utils/apiUtils';
import { STEP_API } from '../../../constant/api_url';
import { toast } from 'react-hot-toast';

export interface DeleteStepMutationVariables {
  id: number;
}

export const useStepsDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, AxiosError, DeleteStepMutationVariables>(
    (data: DeleteStepMutationVariables) => axios.delete(`${STEP_API}/${data.id}`),
    {
      onError: (err, _, context) => {
        toast.error('Nepodařilo se vymazat krok');
      },
      onSuccess: (data) => {
        toast.success('Krok vymazán');
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey[0] === STEP_API,
        });
      },
    },
  );
};
